import { CommonModule } from '@angular/common'
import {
    AfterContentInit,
    Component,
    ContentChildren,
    Input,
    OnDestroy,
    QueryList,
} from '@angular/core'
import { ToggleBehavior } from '@shared-ui-lib/accordion/accordion.model'
import { CollapsibleComponent } from '@shared-ui-lib/collapsible/collapsible.component'
import { isTruthy } from '@util-lib/isTruthy'
import { BehaviorSubject, Subscription, combineLatest, filter } from 'rxjs'

@Component({
    selector: 'app-accordion',
    styleUrls: ['./accordion.component.scss'],
    templateUrl: './accordion.component.html',
    standalone: true,
    imports: [CommonModule],
})
export class AccordionComponent implements AfterContentInit, OnDestroy {
    @ContentChildren(CollapsibleComponent)
    private readonly collapsibles?: QueryList<CollapsibleComponent>

    private toggleBehavior$ = new BehaviorSubject<ToggleBehavior>('openOnlyOne')
    @Input()
    set toggleBehavior(value: ToggleBehavior) {
        this.toggleBehavior$.next(value)
    }

    subscriptions = new Subscription()

    collapsiblesStates: boolean[] = []

    collapsibleOpened$ = new BehaviorSubject<number | undefined>(undefined)

    ngAfterContentInit(): void {
        this.collapsiblesStates = new Array(this.collapsibles?.length).fill(
            true
        )

        this.collapsibles?.toArray().forEach((collapsible, index) => {
            this.subscriptions.add(
                collapsible.collapsed.subscribe((collapsed) => {
                    this.collapsiblesStates[index] = collapsed
                    if (!collapsed) {
                        this.collapsibleOpened$.next(index)
                    }
                })
            )
        })

        this.subscriptions.add(
            combineLatest([
                this.collapsibleOpened$.pipe(
                    filter((index) => index !== undefined)
                ),
                this.toggleBehavior$.pipe(
                    filter(isTruthy),
                    filter((toggleBehavior) => toggleBehavior === 'openOnlyOne')
                ),
            ]).subscribe(([indexOfOpenCollapsible]) => {
                this.collapsiblesStates.forEach((collapsed, index) => {
                    if (!collapsed && index !== indexOfOpenCollapsible) {
                        this.collapsibles?.get(index)?.onCollapsibleClick()
                    }
                })
            })
        )
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe()
    }
}
